import { useMediaQuery } from "@material-ui/core";

export function MobileDevice({children}) {
    const isMobile = useMediaQuery('(max-width:800px)');
    return (isMobile ? children : null);
}

export function DesktopDevice({children}) {
    const isDesktop = useMediaQuery('(min-width:801px)');
    return (isDesktop ? children : null);
}